import type { ProjectHeaderActionsProps } from "./project-header-actions.type";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import ProgressButton from "@/components/Header/Button/ProgressButton";
import { useAuthorization } from "@/modules/authorization";
import { ProjectAssignButton } from "@/modules/project/project-assign";
import { ProjectEditButton } from "@/modules/project/project-edit-button";
import { ProjectInfoButton } from "@/modules/project/project-info-button";
import { StateEditForm } from "@/modules/state-edit-form";
import { ActionsBar } from "@/ui/actions-bar";

export const ProjectHeaderActions = ({
  project,
  loading,
}: ProjectHeaderActionsProps) => {
  const { canUpdateItem, canAssignItem, canDeleteItem } = useAuthorization();

  if (!project || loading) return null;

  return (
    <ActionsBar
      primaryActions={[
        {
          key: "state",
          node: <StateEditForm stateType="project" model={project} />,
        },
        {
          key: "progress",
          node: (
            <ProgressButton type="project" model={project} isEditable={false} />
          ),
        },
        {
          key: "info",
          node: <ProjectInfoButton project={project} />,
        },
      ]}
      secondaryActions={[
        {
          key: "assign",
          hidden: !canAssignItem(project),
          node: <ProjectAssignButton project={project} type="text" />,
        },
        {
          key: "edit",
          hidden: !canUpdateItem(project),
          node: <ProjectEditButton project={project} type="text" />,
        },
        {
          key: "delete",
          hidden: !canDeleteItem(project),
          node: (
            <DeleteButton
              modelKey="project"
              model={project}
              buttonProps={{ type: "text" }}
            />
          ),
        },
      ]}
    />
  );
};
